import { DocLayout } from './DocLayout';

export default function DocJurnal() {
  return (
    <DocLayout title="Jurnal de audit">
      <h2>Prezentare generală</h2>
      <p>
        Jurnalul de audit înregistrează automat toate modificările aduse activităților:
        creare, actualizare și ștergere. Funcționalitate disponibilă doar superadminilor.
      </p>

      <h2>Informații înregistrate</h2>
      <p>Pentru fiecare acțiune se salvează:</p>
      <ul>
        <li><strong>Activitate</strong> — titlul activității afectate.</li>
        <li><strong>Utilizator</strong> — cine a făcut modificarea.</li>
        <li><strong>Acțiune</strong> — Creat, Actualizat sau Șters.</li>
        <li><strong>Modificări</strong> — detalii despre ce s-a schimbat (valoare veche → valoare nouă).</li>
        <li><strong>Data și ora</strong> — momentul exact al acțiunii.</li>
      </ul>

      <h2>Filtrare</h2>
      <p>Poți filtra jurnalul după tipul acțiunii (Creat, Actualizat, Șters) pentru a găsi rapid ceea ce cauți.</p>

      <h2>Scop</h2>
      <p>
        Jurnalul ajută la urmărirea istoricului modificărilor, identificarea cine a făcut o anumită schimbare
        și rezolvarea eventualelor probleme legate de conținut.
      </p>
    </DocLayout>
  );
}
